import nasaLogo from "./assets/nasa-logo.png";
import nwsLogo from "./assets/nws-logo.png";
import usgsLogo from "./assets/usgs-logo.png";

export const footerItems = {
    dataSources: [
      {
        name: "usgs-logo",
        desc: "Visit the U.S. Geological Survey (USGS)",
        src: usgsLogo,
        link: "https://www.usgs.gov",
        type: "image",
      },
      // {
      //   name: "SIFTA",
      //   src: "",
      //   link: "https://sifta.water.usgs.gov/",
      //   type: "text",
      // },
      // {
      //   name: "SIMS",
      //   src: "",
      //   link: "https://sims.water.usgs.gov/SIMS/",
      //   type: "text",
      // },
    ],
    textButtons: [
      { name: "NGWOS Home", link: "https://www.usgs.gov/mission-areas/water-resources/science/next-generation-water-observing-system-ngwos", desc: "NGWOS Home" },
      { name: "Data Editor Guide", link: "https://doimspp.sharepoint.com/:o:/r/sites/usgs-Integrated-Water-Science-Data-Management/SiteAssets/Integrated%20Water%20Science%20Data%20Management%20Notebook?d=w3fd4988c987344028a75dc9066722dce&csf=1&web=1&e=EXXvsB", desc: "How to add a project + dataset" },
      // { name: "Support", link: "mailto:gs_nwdi_help@usgs.gov", desc: "Send an email to the support team" },
    ],
  };